import React from "react";
import {useState, useEffect} from "react";
import {useSelector} from "react-redux";
import "../../assets/css/pages/categories.css";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import swal from 'sweetalert';
import EditAttribute from "./EditAttributeComponent";

export default function ({
                           attribute,
                           indexa,
                           triggerAttributesLoop,
                           categoryWithAttributes,
                           setCategoryWithAttributes
                         }) {

  const navigate = useNavigate();
  const token = useSelector(state => state.token);
  const [showAttributes, setShowAttributes] = useState(false);
  const [categoryWithAttributesArray, setCategoryWithAttributesArray] = useState();

  const [newValue, setNewValue] = useState();

  const [editFormIsOpen, setEditFormIsOpen] = useState(false);

  useEffect(() => {
    setCategoryWithAttributesArray(attribute);
  }, [attribute]);


  const deleteAttribute = (id, name) => {
    swal({
      title: "Are you sure?",
      text: 'You want to delete attribute "' + name + '"?',
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.delete('attributes/' + id).then(function (res) {
          if (res.status === 200) {
            swal('The attribute "' + name + '" has been deleted!', {
              icon: "success",
            });
            triggerAttributesLoop(id);
            return true;
          } else {
            return false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    });
  }

  const deleteAttributeValue = (id, name) => {
    swal({
      title: "Are you sure?",
      text: 'You want to delete attribute value "' + name + '"?',
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.delete('attributes/values/' + id).then(function (res) {
          if (res.status === 200) {
            swal('The attribute value "' + name + '" has been deleted!', {
              icon: "success",
            });
            triggerAttributesLoop(id);
            return true;
          } else {
            return false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    });
  }

  const toggleAttributeShow = (attributeId) => {

    axios.post(`/attributes/${attributeId}/categories/${categoryWithAttributes.id}/toggle-show`).then(res => {
      const newAttributes = categoryWithAttributes.attributes.map((item) => item.id == attributeId ? {
        ...item,
        show: !item.show
      } : item);

      setCategoryWithAttributes({...categoryWithAttributes, attributes: newAttributes})
    });
  }

  const loopValues = (valuesArray) => {
    return valuesArray.map((attrValue, index) =>
      <div key={index} className={`col-xxl-4 col-xl-6 p-3 value${attrValue.name == "" ? " d-none" : ""}`}>
        <div
          className="border rounded py-2 px-3"
        >
          <div className="actions mr-3">
            <span
              className="action p-2 bg-primary mx-1"
              onClick={(e) => {
                navigate("/attributes/values/" + attrValue.id + "/edit");
              }}
            >
              <i className="far fa-edit text-white mx-1"></i>
            </span>
            <span
              className="action p-2 py-2 px-3 bg-danger"
              onClick={(e) => {
                deleteAttributeValue(attrValue.id, attrValue.name);
              }}
            >
              <i className="far fa-trash-alt text-white"></i>
            </span>
          </div>
          <span className="name my-2">
            {attrValue.name}
          </span>
        </div>
      </div>
    )
  }

  const addNewValue = (attributeId) => {
    axios.post('attributes/' + attributeId + '/values', {name: newValue}).then(function (res) {
      if (res.status === 200) {
        swal('The attribute value "' + newValue + '" has been created successfully!', {
          icon: "success",
        });

        triggerAttributesLoop(attributeId);
        setNewValue("");
        return true;
      } else {
        return false;
      }
    }).catch(function (error) {
      console.log(error);
    });
  }

  return (
    <>
      <div key={indexa} className="col-12">
        <div
          className={`card category-attribute py-3 px-4 mb-4${(showAttributes || editFormIsOpen) ? "" : " h-4-5-rem"}`}>
          <div className="d-block">
            <div className="name-label d-inline-block">
              <i
                className={`fas fa-${editFormIsOpen ? "times-circle" : "edit"} mr-3 fs-4 d-inline cursor-pointer`}
                title={editFormIsOpen ? "Close Edit" : "Edit"}
                onClick={() => {
                  setEditFormIsOpen(!editFormIsOpen)
                }}
              ></i>
              <div
                className={`d-inline-block fw-normal fw-bolder ml-3 mt-2 ls-3 fs-5}`}>
                {attribute.name}
              </div>
            </div>
            <div className="main-buttons mt-1">
              <button
                type="button"
                className={`btn btn-primary w-auto py-2 px-4 mr-3${showAttributes ? " bg-color-bo" : ""}`}
                disabled={true}
              >
               # {attribute.position || '-'}
              </button>
              <div className="switch d-inline-block mr-3">
                <label className="form-check form-switch form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={attribute.show}
                    onChange={() => toggleAttributeShow(attribute.id)}
                  />
                  <span className="form-check-label fw-bold text-muted">Show</span>
                </label>
              </div>
              <button
                type="button"
                className={`btn btn-primary w-auto py-2 px-4 mr-3${showAttributes ? " bg-color-bo" : ""}`}
                onClick={(e) => {
                  setShowAttributes(!showAttributes)
                }}
              >
                <i className={`fas fa-${showAttributes ? "times-circle" : "plus"} mr-2 d-inline`}></i>
                {showAttributes ? "Close" : "Add Value"}
              </button>
              <button
                type="button"
                className="btn btn-danger py-2 px-4"
                onClick={() => {
                  deleteAttribute(categoryWithAttributesArray.id, categoryWithAttributesArray.name)
                }}
              >
                <i className="far fa-trash-alt mr-3 d-inline"></i>
                Delete
              </button>
            </div>
          </div>
          <div className={`row pt-7 ls-1${editFormIsOpen ? "" : " display-none"}`}>
            {
              editFormIsOpen && <EditAttribute
                attributeId={attribute.id}
                categoryId={categoryWithAttributes.id}
                setEditFormIsOpen={setEditFormIsOpen}
                callback={triggerAttributesLoop}
              />
            }
          </div>
          <div className={`row values-list pt-7 ls-1${showAttributes ? "" : " display-none"}`}>
            <div className="col-12 mb-5">
              <div className="col-lg-4 py-3">
                <div className="py-2">
                  <label className="form-label fs-6 fw-bolder color-dark-grey">Add new value</label>
                  <input
                    type="text"
                    name="new_value"
                    className="form-control form-control-lg form-control-solid d-inline-block pr-7-rem"
                    onChange={(e) => {
                      setNewValue(e.target.value);
                    }}
                    value={newValue}
                  />
                  <div className="btn-add-value-absolute-div">
                    <span className="btn-add-value p-4 bg-secondary mx-1 h-3-5 px-3 border"
                          onClick={() => {
                            addNewValue(categoryWithAttributesArray.id)
                          }}
                    >
                      <i className="fas fa-plus-circle mr-2 fs-5"></i>
                      Add
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {categoryWithAttributesArray && loopValues(categoryWithAttributesArray?.values)}
          </div>
        </div>
      </div>
    </>
  );
}